// Modules
import { NgModule, ErrorHandler } from '@angular/core';
import { AppModule } from './modules';
import { environment } from '../environments/environment';
import { BrowserCookiesModule } from '@ngx-utils/cookies/browser';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

// Components
import { AppComponent } from './components';

// Services
import { FakeBackendInterceptor } from './services';

// Sentry Error Logging https://sentry.io/snagajob/
import * as Raven from 'raven-js';

if (environment.PRODUCTION && environment.SENTRY_DSN_PUBLIC !== 'undefined'){
  Raven
    .config(environment.SENTRY_DSN_PUBLIC, {
      environment: environment.CIRCLE_BRANCH,
      release: environment.CIRCLE_BUILD_NUM,
      logger : 'javascript',
      tags: {
        git_commit: environment.CIRCLE_SHA1
      }
    }).install();
}


export class SnagErrorHandler implements ErrorHandler {

  handleError(err: any): void {

    if (environment.CIRCLE_BRANCH === 'develop' || environment.CIRCLE_BRANCH === 'qa') {
      console.error(err);
    }
    if (environment.PRODUCTION && environment.SENTRY_DSN_PUBLIC !== 'undefined') Raven.captureException(err.originalError || err);

  }

}

@NgModule({
  imports: [
    BrowserCookiesModule.forRoot(),
    AppModule
  ],
  providers: [
    { provide: ErrorHandler, useClass: SnagErrorHandler }
  ],
  bootstrap: [AppComponent]
})
export class BrowserAppModule {}
